<template>
  <main id="content">
    <section v-if="completed" class="d-flex justify-content-center">
      <div class="text-center" style="max-width: 400px">
        <span class="text-success"
          ><font-awesome-icon icon="check-circle" size="3x"
        /></span>
        <p class="mt-4 h5">{{ thanksMessage }}</p>
      </div>
    </section>
    <section v-else-if="(products || []).length === 0" class="empty-hero">
      <b-container>
        <b-row>
          <b-col md="6" offset-md="3" class="text-center">
            <div class="mb-3">
              <font-awesome-icon icon="shopping-cart" size="4x" />
            </div>
            <h4 class="mb-4">Your shopping cart is empty</h4>
            <div>
              <b-button :to="'/'" variant="light" class="ml-3"
                >Continue shopping<font-awesome-icon icon="arrow-right" />
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <div v-else>
      <section class="hero d-flex justify-content-center">
        <h2>Cart</h2>
      </section>
      <section v-if="loading" class="d-flex justify-content-center">
        <div class="text-center">
          <span class="text-muted">
            <font-awesome-icon icon="sync" spin size="3x" />
          </span>
          <p class="mt-4">{{ paymentMessage }}</p>
        </div>
      </section>
      <section class="pt-5 pb-5" v-else>
        <b-container>
          <b-row>
            <b-col md v-if="products[0]">
              <b-card v-for="product in products" :key="product.productId">
                <b-row>
                  <b-col cols="3">
                    <img alt :src="product.imageUrl" />
                  </b-col>
                  <b-col cols="9">
                    <h3 class="h5">{{ product.name }}</h3>
                    <p class="mt-3">{{ product.desc }}</p>
                    <p class="small mt-3 mb-4">{{ product.footnote }}</p>
                    <div class="mb-4" style="display: inline-block">
                      <b-input-group prepend="Quantity">
                        <b-form-input
                          type="number"
                          step="1"
                          v-model="product.qty"
                          min="0"
                          style="max-width: 100px"
                          @change="updateTotal"
                        />
                      </b-input-group>
                    </div>
                    <h3 class="h5">
                      <span
                        class="text-muted"
                        style="text-decoration: line-through"
                      >
                        ${{
                          (parseInt(product.priceBefore) / 100)
                            .toFixed(2)
                            .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
                        }}
                      </span>
                      <span>
                        ${{
                          (parseInt(product.price) / 100)
                            .toFixed(2)
                            .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
                        }}
                      </span>
                    </h3>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
            <b-col
              md="5"
              class="mt-4 mt-mb-0"
              style="margin-top: 0 !important;"
            >
              <b-card class="gray text-center" style="padding: 1.5%">
                <div v-if="step1">
                  <p>You will be charged</p>
                  <h3 class="mb-4">
                    <span
                      class="text-muted"
                      style="text-decoration: line-through"
                    >
                      ${{
                        (parseInt(totalBefore) / 100)
                          .toFixed(2)
                          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
                      }}
                    </span>
                    <span>
                      ${{
                        (parseInt(total) / 100)
                          .toFixed(2)
                          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
                      }}
                    </span>
                  </h3>
                  <b-btn block variant="primary" size="lg" @click="next"
                    >Secure Checkout<font-awesome-icon icon="arrow-right" />
                  </b-btn>
                </div>

                <div v-if="step2">
                  <p class="text-center">
                    Please enter your billing information
                  </p>
                  <b-form style="text-align: left" @submit.prevent="checkout">
                    <b-form-group label="Full Name">
                      <b-form-input type="text" placeholder="Enter your name" />
                    </b-form-group>
                    <b-form-group label="Phone">
                      <b-form-input
                        type="number"
                        placeholder="Enter your phone number"
                      />
                    </b-form-group>
                    <b-form-group label="Email">
                      <b-form-input
                        type="email"
                        placeholder="Enter your email ID"
                      />
                    </b-form-group>
                    <transition name="fade">
                      <b-button
                        type="submit"
                        variant="primary"
                        style="width: 100%; margin-top: 10px;"
                      >
                        <span v-if="true"
                          >Payment details<font-awesome-icon
                            icon="arrow-right"
                          />
                        </span>
                        <span v-else>
                          Payment details &nbsp;
                          <font-awesome-icon icon="sync" spin />
                        </span>
                      </b-button>
                    </transition>
                  </b-form>
                </div>

                <div v-if="step3">
                  <p class="text-center">
                    Please enter your billing information
                  </p>
                  <b-form style="text-align: left" @submit.prevent="checkout">
                    <b-form-group label="Full Name">
                      <b-form-input type="text" placeholder="Enter your name" />
                    </b-form-group>
                    <b-form-group label="Phone">
                      <b-form-input
                        type="number"
                        placeholder="Enter your phone number"
                      />
                    </b-form-group>
                    <b-form-group label="Email">
                      <b-form-input
                        type="email"
                        placeholder="Enter your email ID"
                      />
                    </b-form-group>
                    <transition name="fade">
                      <b-button
                        type="submit"
                        variant="primary"
                        style="width: 100%; margin-top: 10px;"
                      >
                        <span v-if="true"
                          >Payment details<font-awesome-icon
                            icon="arrow-right"
                          />
                        </span>
                        <span v-else>
                          Payment details &nbsp;
                          <font-awesome-icon icon="sync" spin />
                        </span>
                      </b-button>
                    </transition>
                  </b-form>
                </div>

                <div class="mt-4">
                  <p class="small">
                    <span class="mr-2 text-success">
                      <font-awesome-icon icon="lock" /> </span
                    >We use bank-level 256-byte Transport Layer Security 1.2 to
                    encrypt this transaction. We do not store your credit card
                    information on our servers.
                  </p>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </b-container>
      </section>
    </div>
  </main>
</template>

<script>
import { mapGetters } from "vuex";
import constants from "../modules/constants";

export default {
  data: () => {
    return {
      total: 0,
      totalBefore: 0,
      loading: false,
      completed: false,
      step1: true,
      step2: false,
      step3: false,
      paymentMessage: constants.info.payment,
      thanksMessage: constants.info.thanks
    };
  },
  mounted() {
    this.updateTotal();
  },
  computed: {
    ...mapGetters({
      products: "getCart"
    })
  },
  methods: {
    updateTotal() {
      this.total = 0;
      this.totalBefore = 0;
      for (let i = 0; i < this.products.length; i++) {
        this.total = this.products[i].qty * this.products[i].price;
        this.totalBefore = this.products[i].qty * this.products[i].priceBefore;
      }
      this.$store.dispatch({
        type: "updateCart",
        cart: this.products
      });
    },
    next() {
      this.step1 = false;
      this.step2 = true;
    },
    checkout() {
      this.loading = true;
      // stripe.orders.create(
      //   {
      //     currency: "usd",
      //     items: [
      //       {
      //         type: "sku",
      //         parent: "sku_EdprymGu9Z2XMk"
      //       }
      //     ],
      //     shipping: {
      //       name: "Jenny Rosen",
      //       address: {
      //         line1: "1234 Main Street",
      //         city: "San Francisco",
      //         state: "CA",
      //         country: "US",
      //         postal_code: "94111"
      //       }
      //     },
      //     email: "jenny.rosen@example.com"
      //   },
      //   function(error, order) {
      //     if (error) {
      //       this.$root.toast(constants.errors.payment);
      //       this.loading = false;
      //     } else {
      //       this.completed = true;
      //       this.$store.dispatch("emptyCart");
      //       this.loading = false;
      //       // reveal payment methods
      //       // pay for order start here
      //     }
      //   }
      // );

      // this.$checkout.open({
      // 	name: "DrillMaps",
      // 	currency: "USD",
      // 	amount: this.total,
      // 	token: token => {
      // 		this.loading = true;
      // 		fetch(
      // 			constants.urls.cloudFunctions.charge +
      // 				"?token=" +
      // 				encodeURIComponent(token.id) +
      // 				"&amount=" +
      // 				this.total
      // 		)
      // 			.then(response => response.json())
      // 			.then(json => {
      // 				if (json.captured) {
      // 					this.completed = true;
      // 					this.$store.dispatch("emptyCart");
      // 				}
      // 			})
      // 			.catch(error => {
      // 				this.$root.toast(constants.errors.payment);
      // 			})
      // 			.finally(() => {
      // 				this.loading = false;
      // 			});
      // 	}
      // });
    }
  }
};
</script>

<style lang="scss" scoped>
section.hero,
section.cta {
  padding: 5rem 0;
  background: linear-gradient(to right, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),
    url("../assets/directory-bg.png") no-repeat center center;
  background-size: cover;
  color: #fff;
  .search-input {
    min-width: 30vw;
    max-width: 90vw;
  }
}
.empty-hero {
  padding: 10rem 0;
  color: #fff;
  background: linear-gradient(to right, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.4)),
    url("../assets/home-bg.png") no-repeat center center;
  background-size: cover;
  p {
    margin: 1rem 0 1.75rem 0;
  }
}
@media (max-width: 750px) {
  .empty-hero {
    padding: 4.5rem 0;
  }
}
.card + .card {
  margin-top: 1.5rem;
}
</style>
